/**
 * Google 首登后的「绑个手机号」一次性红点(2026-09-09 拍板:提示一次,能消失)。
 *
 * 状态住在 localStorage:'1' = 挂起(账号菜单的 Settings 行亮点),Settings 页
 * 看到 Phone 行的那一刻记作 '2'(菜单的点熄灭,本次页内仍亮),绑上号即清除。
 * 存储不可用时静默降级成「不提示」。
 */

const KEY = 'ember-phone-hint';

function read(): string {
  try { return localStorage.getItem(KEY) || ''; } catch { return ''; }
}

/** Google 建了新号:点亮。 */
export function armPhoneHint(): void {
  try { localStorage.setItem(KEY, '1'); } catch { /* 降级:不提示 */ }
}

/** 账号菜单读这个:只在还没被 Settings 看过时亮。 */
export function phoneHintArmed(): boolean {
  return read() === '1';
}

/** Settings 看到了这一眼:记作已见,并告知本次要不要亮页内的点。 */
export function markPhoneHintSeen(): boolean {
  const armed = read() === '1';
  if (armed) { try { localStorage.setItem(KEY, '2'); } catch { /* 同上 */ } }
  return armed;
}

/** 号绑上了(或换了账号):提示的事由消失。 */
export function clearPhoneHint(): void {
  try { localStorage.removeItem(KEY); } catch { /* 同上 */ }
}
